<mat-drawer-container autosize class="side-nav-container" hasBackdrop="true" (backdropClick)="onClose()">
  <mat-drawer #sidenav class="menu-sidenav" disableClose mode="over" (keydown.escape)="onClose()">
    <div class="menu-sidenav-content-container" tabindex="0">
      <app-menu-user-info
        [activeDealer]="activeDealer()"
        [dealers]="dealers()"
        [onClose]="onCloseMethod"
        [selectedTheme]="selectedTheme$ | async"
        [user]="user()"
      />
      <mat-divider />
      <div class="content-container">
        <div class="navigation-container">
          @if (canMakeSales()) {
            <button
              class="sale-button"
              data-testid="start-sale-button"
              [routerLink]="diegoRoutes.startSale"
              (click)="onClose()"
            >
              Salg
            </button>
          }
          <div class="navigation-links-container">
            <div class="navigation-section">
              @if (canMakeSales()) {
                <div class="order-history-container">
                  <a
                    class="menu-button"
                    data-testid="menu-button-order-history-link"
                    routerLinkActive="menu-button-active"
                    [routerLink]="diegoRoutes.orderHistory"
                    (click)="onClose()"
                  >
                    <mat-icon [svgIcon]="IconNames.ice_time" />
                    <span>Ordrehistorikk</span>
                  </a>
                  @if (canUpdateImei()) {
                    @if (ordersWithMissingImeis().isLoading) {
                      <span class="missing-imeis-skeleton"></span>
                    } @else if (ordersWithMissingImeis().count > 0) {
                      <a
                        class="missing-imeis"
                        data-testid="menu-button-missing-imeis-link"
                        [queryParams]="missingImeiQueryParams"
                        [routerLink]="diegoRoutes.orderHistory"
                        (click)="onClose()"
                      >
                        {{ ordersWithMissingImeis().count }} mangler IMEI
                      </a>
                    }
                  }
                </div>
              }
              @if (hasSalesCompetitionClaim() || isCompetitionAdmin()) {
                <a
                  class="menu-button"
                  data-testid="menu-button-competition"
                  routerLinkActive="menu-button-active"
                  [routerLink]="diegoRoutes.competition"
                  (click)="onClose()"
                >
                  <mat-icon [svgIcon]="IconNames.ice_trophy" />
                  <span>Konkurranser</span>
                </a>
              }
              @if (featureSalesBattle) {
                <a
                  class="menu-button"
                  data-testid="menu-button-sales-battle-link"
                  routerLinkActive="menu-button-active"
                  [routerLink]="diegoRoutes.salesBattle"
                  (click)="onClose()"
                >
                  <mat-icon [svgIcon]="IconNames.ice_cart" />
                  <span>SalesBattle</span>
                </a>
              }
              <a
                class="menu-button"
                data-testid="menu-button-battlecards-link"
                routerLinkActive="menu-button-active"
                [routerLink]="diegoRoutes.battlecards"
                (click)="onClose()"
              >
                <mat-icon [svgIcon]="IconNames.ice_bullet_list" />
                <span>Abonnementoversikt</span>
              </a>
            </div>
            <div class="navigation-section">
              @if ({ dealer: activeDealer(), user: user() }; as data) {
                <a
                  class="menu-button"
                  data-testid="menu-button-support-details-link"
                  routerLinkActive="menu-button-active"
                  [routerLink]="diegoRoutes.supportDetails"
                  (click)="onClose()"
                >
                  <mat-icon [svgIcon]="IconNames.ice_chat" />
                  <span>Support</span>
                </a>
                <a
                  aria-haspopup="dialog"
                  class="menu-button"
                  data-testid="menu-button-feedback-link"
                  role="button"
                  tabindex="0"
                  (click)="openFeedbackDialog(data)"
                  (keydown.enter)="openFeedbackDialog(data)"
                >
                  <mat-icon [svgIcon]="IconNames.ice_message" />
                  <span>Tilbakemelding</span>
                </a>
              }
              @if ({ user: user() }; as data) {
                <a
                  aria-haspopup="dialog"
                  class="menu-button"
                  data-testid="menu-button-error-link"
                  role="button"
                  tabindex="0"
                  test-id="menu-button-error"
                  (click)="openErrorDialog(data)"
                  (keydown.enter)="openErrorDialog(data)"
                >
                  <mat-icon [svgIcon]="IconNames.ice_warning" />
                  <span>Meld feil til forhandlersupport</span>
                </a>
              }
            </div>
            <mat-expansion-panel class="other-tools-container">
              <mat-expansion-panel-header>
                <mat-panel-title class="other-tools-text">Andre verktøy</mat-panel-title>
              </mat-expansion-panel-header>
              <a
                *appAllowSettings="[DealerClaimType.CanOrderBulkSim]"
                class="menu-button-other-tools"
                data-testid="menu-button-order-bulk-sim-link"
                routerLinkActive="menu-button-active"
                [routerLink]="diegoRoutes.orderBulkSim"
                (click)="onClose()"
              >
                <span>Bestill SIM</span>
              </a>
              <a
                *appAllowSettings="[DealerClaimType.CanCreateCustomerOnly]"
                class="menu-button-other-tools"
                data-testid="menu-button-register-customer-link"
                routerLinkActive="menu-button-active"
                [routerLink]="diegoRoutes.registerCustomer"
                (click)="onClose()"
              >
                <span>Opprett ny kunde</span>
              </a>
              <a
                *appAllowSettings="[DealerClaimType.CanAdministerSellers]"
                class="menu-button-other-tools"
                data-testid="menu-button-sellers-link"
                routerLinkActive="menu-button-active"
                [routerLink]="diegoRoutes.sellers"
                (click)="onClose()"
              >
                <span>Selgere</span>
              </a>
              <a
                class="menu-button-other-tools"
                data-testid="menu-button-btob-link"
                href="{{ salesForceUrl }}"
                target="_blank"
              >
                <span>Salg bedrift</span>
                <mat-icon [svgIcon]="IconNames.ice_external_link" />
              </a>
              <a
                class="menu-button-other-tools bottom-button"
                data-testid="menu-button-other-tools-link"
                href="https://www.ice.no/dekning"
                tabindex="0"
                target="_blank"
              >
                <span>Dekningskart</span>
                <mat-icon [svgIcon]="IconNames.ice_external_link" />
              </a>
            </mat-expansion-panel>
          </div>
        </div>
        @if (salesSummary(); as salesSummary) {
          <div class="sales-info-container">
            <mat-expansion-panel [expanded]="showSalesSummary" (closed)="panelClosed()" (opened)="panelOpened()">
              <mat-expansion-panel-header>
                <mat-panel-title class="your-sales-text">Dine salg</mat-panel-title>
              </mat-expansion-panel-header>
              <app-menu-sales-summary [salesSummary]="salesSummary" />
            </mat-expansion-panel>
          </div>
        }
      </div>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <ng-content />
  </mat-drawer-content>
</mat-drawer-container>
